import {
    RESERVES_UPDATE_REACTIVE,
    STRONGHOLD_UPGRADE_REACTIVE,
} from 'channels/clan/actions'

import { RESERVE_TYPES } from 'constants'

import { ACCOUNT_INFO_SUCCESS } from 'state/actions/account'
import { RESERVE_ACTIVATION_SUCCESS } from 'state/actions/reserve_activation'
import { RESERVE_PRODUCE_CANCEL_SUCCESS } from 'state/actions/reserve_produce_cancel'
import { RESERVE_PRODUCE_SUBMIT_SUCCESS } from 'state/actions/reserve_produce'
import { SLOT_INFO_SUCCESS } from 'state/actions/slots'


const initialState = {
    [RESERVE_TYPES.BATTLE_PAYMENTS]: [],
    [RESERVE_TYPES.MILITARY_MANEUVERS]: [],
    [RESERVE_TYPES.TACTICAL_TRAINING]: [],
    [RESERVE_TYPES.ADDITIONAL_BRIEFING]: [],
    [RESERVE_TYPES.HIGH_CAPACITY_TRANSPORT]: [],
    [RESERVE_TYPES.REQUISITION]: [],
    [RESERVE_TYPES.ARTILLERY_STRIKE]: [],
    [RESERVE_TYPES.INSPIRATION]: [],
}

const addTimings = reserves => {
    if (!reserves) return []
    return reserves.map((reserve) => {
        let productionEnds
        let effectEnds
        if (reserve.production_in_progress) {
            productionEnds = Date.now() + reserve.production_elapsed * 1000
        } else {
            productionEnds = null
        }

        if (reserve.is_effective) {
            effectEnds = Date.now() + reserve.effective_for * 1000
        } else {
            effectEnds = null
        }

        return {
            ...reserve,
            productionEnds,
            effectEnds,
        }
    })
}

export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
    case ACCOUNT_INFO_SUCCESS: {
        if (!action.payload.clan) return state
        const { reserves } = action.payload.clan
        return Object.keys(reserves).reduce((acc, reserveType) => ({
            ...acc,
            [reserveType]: addTimings(reserves[reserveType]),
        }), state)
    }
    case SLOT_INFO_SUCCESS: {
        const { reserves, reserve } = action.payload.slot
        if (!reserves) return state
        return {
            ...state,
            [reserve.type]: addTimings(reserves),
        }
    }
    case RESERVE_PRODUCE_SUBMIT_SUCCESS: {
        const reserveQueue = addTimings(action.payload.producedReserves)
        const reserveType = reserveQueue[0].type
        return {
            ...state,
            [reserveType]: reserveQueue,
        }
    }
    case RESERVE_PRODUCE_CANCEL_SUCCESS: {
        const { reserveType, reserves } = action.payload
        return {
            ...state,
            [reserveType]: addTimings(reserves),
        }
    }
    case RESERVE_ACTIVATION_SUCCESS: {
        const { reserves } = action.payload
        return Object.keys(reserves).reduce((acc, reserveType) => ({
            ...acc,
            [reserveType]: addTimings(reserves[reserveType]),
        }), state)
    }
    case RESERVES_UPDATE_REACTIVE: {
        const { reserves, reserveType } = action.payload
        return {
            ...state,
            [reserveType]: addTimings(reserves),
        }
    }
    case STRONGHOLD_UPGRADE_REACTIVE: {
        const { reserves } = action.payload
        return Object.keys(reserves).reduce((acc, reserveType) => ({
            ...acc,
            [reserveType]: addTimings(reserves[reserveType]),
        }), state)
    }
    default:
        return state
    }
}



// WEBPACK FOOTER //
// ./state/reducers/clan_reserves.js